import { render, staticRenderFns } from "./servicerequest.vue?vue&type=template&id=6490604c"
import script from "./servicerequest.vue?vue&type=script&lang=js"
export * from "./servicerequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports